import { render } from "./UserMenuComponent.vue?vue&type=template&id=b93ca6b2&scoped=true"
import script from "./UserMenuComponent.vue?vue&type=script&lang=js"
export * from "./UserMenuComponent.vue?vue&type=script&lang=js"

import "./UserMenuComponent.vue?vue&type=style&index=0&id=b93ca6b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b93ca6b2"]])

export default __exports__